export class Message {
  type: string;
  icon: string;
  code: string;
  errorObject: Object;
  messageHtml?: string;
  extraHtml?: string;
}
